export default __webpack_public_path__ + "static/media/Perfil-mentor.a9c25462.png";